// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.white-background{
    background-color: white;
}
:host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
.light-grey-background {
    background-color: rgb(234, 231, 231);
  }
.search-form {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.delegation-table {
    width: 100%;
    border-collapse: collapse;
}

.delegation-table th, .delegation-table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.delegation-table th {
    background-color: #f4f4f4;
}

/* Style for the table container */
.example-container {
    overflow: auto;
    width:100%;
    border:2px solid  #286090;
    border-radius:10px;
    margin:2% 0%;
}
.select-text
{
    color:white;
    background-color: #286090;
    text-align: left;
    padding-left:1%;
}
/* Style for the table */
table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto; /* Ensures columns adjust to content */
}

/* Style for table headers */
th {
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

/* Style for table cells */
td {
    border: 1px solid #ddd;
    padding: 8px;
}

/* Style for input fields in headers */
th input {
    width: 100%;
    box-sizing: border-box;
    padding: 4px;
    margin-top: 4px;
}

/* Style for action links */
a {
    color: #007bff;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

/* For spinner */
.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh; /* Adjust this as needed */
}

mat-spinner {
    margin: auto;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.center-content {
    margin: auto !important;
    text-align: center;
}

.searchFilter {
    display: grid;
    padding-bottom: 10px;
}

.red-icon {
    color: red;
}

/* Adjust column widths */
.mat-column-startDate,
.mat-column-endDate,
.mat-column-dueTo,
.mat-column-toName,
.mat-column-from_Name,
.mat-column-createdBy,
.mat-column-created,
.mat-column-modify,
.mat-column-action {
    flex: 1 1 auto;
    min-width: 150px; /* Ensure minimum width */
}

.material-table-scrollbar {
    overflow: visible;
    height: auto;
  }

  .custom-dialog-container {
    margin: 0 auto;
    left: 0;
    right: 0;
  }

  .sub-container{
    width:100%;
    border:2px solid gray;
    /* background-color: rgb(234, 228, 228); */
    border-radius:10px;
    margin:0%;
    padding-left: 2%;
    padding-right: 2%;
    padding: 2%;
  }`, "",{"version":3,"sources":["webpack://./src/app/admin/modifytempararydoa/modifytempararydoa.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,wEAAwE;AAC5E;AACA;IACI,oCAAoC;EACtC;AACF;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,kCAAkC;AAClC;IACI,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;AACA;;IAEI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;AACA,wBAAwB;AACxB;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB,EAAE,sCAAsC;AAC9D;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa,EAAE,0BAA0B;AAC7C;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA,yBAAyB;AACzB;;;;;;;;;IASI,cAAc;IACd,gBAAgB,EAAE,yBAAyB;AAC/C;;AAEA;IACI,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,qBAAqB;IACrB,0CAA0C;IAC1C,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb","sourcesContent":[".white-background{\n    background-color: white;\n}\n:host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\n.light-grey-background {\n    background-color: rgb(234, 231, 231);\n  }\n.search-form {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.delegation-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.delegation-table th, .delegation-table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n.delegation-table th {\n    background-color: #f4f4f4;\n}\n\n/* Style for the table container */\n.example-container {\n    overflow: auto;\n    width:100%;\n    border:2px solid  #286090;\n    border-radius:10px;\n    margin:2% 0%;\n}\n.select-text\n{\n    color:white;\n    background-color: #286090;\n    text-align: left;\n    padding-left:1%;\n}\n/* Style for the table */\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: auto; /* Ensures columns adjust to content */\n}\n\n/* Style for table headers */\nth {\n    background-color: #f2f2f2;\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: left;\n}\n\n/* Style for table cells */\ntd {\n    border: 1px solid #ddd;\n    padding: 8px;\n}\n\n/* Style for input fields in headers */\nth input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 4px;\n    margin-top: 4px;\n}\n\n/* Style for action links */\na {\n    color: #007bff;\n    text-decoration: none;\n}\n\na:hover {\n    text-decoration: underline;\n}\n\n/* For spinner */\n.spinner-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100vh; /* Adjust this as needed */\n}\n\nmat-spinner {\n    margin: auto;\n    position: absolute;\n    top: 70%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}\n\n.searchFilter {\n    display: grid;\n    padding-bottom: 10px;\n}\n\n.red-icon {\n    color: red;\n}\n\n/* Adjust column widths */\n.mat-column-startDate,\n.mat-column-endDate,\n.mat-column-dueTo,\n.mat-column-toName,\n.mat-column-from_Name,\n.mat-column-createdBy,\n.mat-column-created,\n.mat-column-modify,\n.mat-column-action {\n    flex: 1 1 auto;\n    min-width: 150px; /* Ensure minimum width */\n}\n\n.material-table-scrollbar {\n    overflow: visible;\n    height: auto;\n  }\n\n  .custom-dialog-container {\n    margin: 0 auto;\n    left: 0;\n    right: 0;\n  }\n\n  .sub-container{\n    width:100%;\n    border:2px solid gray;\n    /* background-color: rgb(234, 228, 228); */\n    border-radius:10px;\n    margin:0%;\n    padding-left: 2%;\n    padding-right: 2%;\n    padding: 2%;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
